import { Icon } from '@chakra-ui/react';
import { MdHome, MdOutlineShoppingCart } from 'react-icons/md';
import { AITrainer, aiCalendarManagement, aiLead, barChart, logoutIcon, teamIcon } from 'components/icons/Icons';
import AccountSettings from 'pages/AccountSettings';
import ActivityTracker from 'pages/ActivityTracker';
import Dashboard from 'pages/Dashboard';
import UIKIT from 'pages/UI-kit';
import PasswordRecovery from 'pages/PasswordRecovery';
import Team from 'pages/Team';
import SingleTeam from 'pages/SingleTeam';
import SingleTeamChangeVariables from 'pages/SingleTeamChangeVariables';
import PasswordReset from 'pages/PasswordReset';
import SignUp from 'pages/SignUp';
import SignIn from 'pages/SignIn';
import Invited from 'pages/Invited';

const W = '24px';
const H = '24px';

const DASHBOARD = {
    name: 'Dashboard',
    layout: '/admin',
    fullPath: '/admin/dashboard',
    path: '/dashboard',
    icon: <Icon as={MdHome} width={W} height={H} color="inherit" />,
    component: <Dashboard />,
};

const ACTIVITY_TRACKER = {
    name: 'Activity Tracker',
    layout: '/admin',
    fullPath: '/admin/activity-tracker',
    path: '/activity-tracker',
    icon: <Icon as={barChart} width={W} height={H} color="inherit" />,
    component: <ActivityTracker />,
};

const AI_LEAD_DELEGATION = {
    name: 'AI Lead Delegation',
    layout: '/admin',
    fullPath: '/admin/ai-lead-delegation',
    path: '/ai-lead-delegation',
    icon: <Icon as={aiLead} width={W} height={H} color="inherit" />,
    component: <div>AI Lead Delegation</div>,
};

const AI_CALENDAR_MANAGEMENT = {
    name: 'AI Calendar Management',
    layout: '/admin',
    fullPath: '/admin/ai-calendar-management',
    path: '/ai-calendar-management',
    icon: <Icon as={aiCalendarManagement} width={W} height={H} color="inherit" />,
    component: <div>AI Calendar Management</div>,
};

const AI_TRAINER = {
    name: 'AI Trainer',
    layout: '/admin',
    fullPath: '/admin/ai-trainer',
    path: '/ai-trainer',
    icon: <Icon as={AITrainer} width={W} height={H} color="inherit" />,
    component: <div>AI Trainer</div>,
};

const TEAM = {
    name: 'Team',
    layout: '/admin',
    fullPath: '/admin/team',
    path: '/team',
    icon: <Icon as={teamIcon} width={W} height={H} color="inherit" />,
    component: <Team />,
};

const SINGLE_TEAM = {
    name: 'Team',
    layout: '/admin',
    fullPath: '/admin/team/:slug/agents',
    path: '/team/:slug',
    icon: <Icon as={teamIcon} width={W} height={H} color="inherit" />,
    component: <SingleTeam />,
};

const SINGLE_TEAM_CHANGE_VARIABLES = {
    name: 'Team',
    layout: '/admin',
    path: SINGLE_TEAM.path + '/variables',
    icon: <Icon as={teamIcon} width={W} height={H} color="inherit" />,
    component: <SingleTeamChangeVariables />,
};

const ACCOUNT_SETTINGS = {
    name: 'Account Settings',
    layout: '/admin',
    fullPath: '/admin/account-settings',
    path: '/account-settings',
    icon: <Icon as={MdOutlineShoppingCart} width={W} height={H} color="inherit" />,
    component: <AccountSettings />,
};

const SIGN_UP = {
    name: 'Sign Up',
    layout: '/auth',
    fullPath: '/auth/sign-up',
    path: '/sign-up',
    component: <SignUp />,
};

export const SIGN_OUT = {
    name: 'Sign Out',
    layout: '/auth',
    fullPath: '/auth/sign-in',
    path: '/sign-in',
    icon: <Icon as={logoutIcon} width={W} height={H} color="inherit" />,
    component: <SignIn />,
};

const PASSWORD_RECOVERY = {
    name: 'Password Recovery',
    layout: '/auth',
    fullPath: '/auth/password-recovery',
    path: '/password-recovery',
    component: <PasswordRecovery />,
};

const PASSWORD_RESET = {
    name: 'Password Reset',
    layout: '/auth',
    fullPath: '/auth/reset',
    path: '/reset',
    component: <PasswordReset />,
};

const INVITED = {
    name: 'Invited',
    layout: '/auth',
    fullPath: '/auth/invited',
    path: '/invited',
    component: <Invited />,
};

const UI_KIT = {
    name: 'UI kit',
    layout: '/admin',
    path: '/ui-kit',
    component: <UIKIT />,
};

export const ROUTES = {
    dashboard: DASHBOARD,
    activity_tracker: ACTIVITY_TRACKER,
    ai_lead_delegation: AI_LEAD_DELEGATION,
    ai_calendar_management: AI_CALENDAR_MANAGEMENT,
    ai_trainer: AI_TRAINER,
    team: TEAM,
    single_team: SINGLE_TEAM,
    account_settings: ACCOUNT_SETTINGS,
    sign_up: SIGN_UP,
    sign_out: SIGN_OUT,
    password_recovery: PASSWORD_RECOVERY,
    reset_password: PASSWORD_RESET,
    invited: INVITED,
};

export const MAIN_URL = '/admin/default';

export const sidebarRoutes = [
    DASHBOARD,
    ACTIVITY_TRACKER,
    AI_LEAD_DELEGATION,
    AI_CALENDAR_MANAGEMENT,
    AI_TRAINER,
    TEAM,
];

export const allRoutes = [
    DASHBOARD,
    ACTIVITY_TRACKER,
    AI_LEAD_DELEGATION,
    AI_CALENDAR_MANAGEMENT,
    AI_TRAINER,
    TEAM,
    ACCOUNT_SETTINGS,
    SIGN_UP,
    SIGN_OUT,
    PASSWORD_RECOVERY,
    UI_KIT,
    SINGLE_TEAM,
    SINGLE_TEAM_CHANGE_VARIABLES,
    PASSWORD_RESET,
    INVITED,
];
